import { forwardRef } from 'react';
import { MatchConfidence } from '@mews-commander/guest-profile';
import { lt } from '@mews/framework';
import { createHandler } from '@mews/std';
import { IconName, Tag, TagProps, TagVariant, Tooltip } from '@optimus-web/core';

const getConfidenceTagColor = createHandler<MatchConfidence, TagVariant>(
    {
        [MatchConfidence.High]: 'lime',
        [MatchConfidence.Medium]: 'denim',
        [MatchConfidence.Low]: 'mustard',
        [MatchConfidence.VeryLow]: 'ruby',
    },
    'basicSubtle'
);

const TagComponent = forwardRef<HTMLDivElement, TagProps>(({ ...props }: TagProps, ref) => (
    <Tag {...props} ref={ref} trailingIcon={IconName.Info} />
));

const TooltippedTagComponent = Tooltip(TagComponent);

export const ConfidenceTag = ({ confidence }: { confidence: MatchConfidence }) => {
    const tagColor = getConfidenceTagColor(confidence);

    return (
        <TooltippedTagComponent tooltip={lt('AccountMergeMatchConfidenceTagTooltip')} variant={tagColor}>
            {lt('AccountMergeMatchConfidenceTagLabel')}
        </TooltippedTagComponent>
    );
};
